import React, { useState } from "react";

export default function CardInFo({data}) {
    const [expanded, setExpanded] = useState({});
    const isExpanded = expanded[data.id];
    const imageSrc = data.img?.startsWith('http')
        ? data.img
        : `${process.env.PUBLIC_URL}/${String(data.img || '').replace(/^\/+/, '')}`;

    const toggleExpand = (id) => {
        setExpanded((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };
    return (
        <article className="card card_info" key={data.id}>
            <div className="card_info-media">
                <img src={imageSrc} alt="Carbon Footprint" />
            </div>
            <div className="card-content">
                <div className="details">
                    {data.detail && <div className="card-kicker">Landscape CFO Guide</div>}
                    <div className="card-title">{data.title}</div>
                    {data.detail && <p className="card-summary">{data.detail}</p>}
                    <div className={`card-text ${isExpanded ? "expanded" : ""}`} id={`card_${data.id}`}>
                        <ul>
                            {data.moreinfo.map((info, index) => (
                                <React.Fragment key={index}>
                                    <li className="my-1">{info}</li>
                                    <hr />
                                </React.Fragment>
                            ))}
                            {data.gridData && <span>{data.gridData}</span>}
                            {data.reference && <span className="text-danger">{data.reference}</span>}
                        </ul>
                    </div>
                </div>
                {data.moreinfo.length > 2 && (
                    <button type="button" className="read-more" onClick={() => toggleExpand(data.id)}>
                        {isExpanded ? "ย่อข้อความ" : "อ่านเพิ่มเติม"}
                    </button>
                )}
                {data.gridData && ( 
                    <button type="button" className="read-more" onClick={() => toggleExpand(data.id)}>
                        {isExpanded ? "ย่อข้อความ" : "อ่านเพิ่มเติม"}
                    </button>
                )}
            </div>
        </article>
    )
};